<template>
<div class="quick-status" v-if="itemStatuses.length > 0">

  <div class="status-trigger" v-click-outside="hide" @click.exact="showOptions = !showOptions" @click.ctrl="setStatusFromLastSetStatus" v-tooltip.left="latestStatus.length > 0 ? latestStatus[0].OrdersAndItemsStatus.title : 'No Status'" :style="{backgroundColor: latestStatus.length > 0 ? latestStatus[0].OrdersAndItemsStatus.colorCode : 'rgb(224, 224, 224)'}">
    <b-spinner v-show="processing"  class="spinner" label="Spinning" style="width: 1.5rem; height: 1.5rem;" ></b-spinner>
  </div>
<transition name="fade">
  <ul class="statusSetterList" v-if="showOptions">
    <li v-for="status in itemStatuses" v-bind:key="status.value" :style="{borderLeftColor: status.colorCode}" @click="setStatus(status)">{{ status.text }}</li>
  </ul>
</transition>
</div>
</template>

<script>
import OrderStatusesService from '../../../services/order-statuses.service'
import {removeDuplicates} from '../../../helpers/array.helpers'
import OrderTagsService from '../../../services/order-tags.service';
import EventBus from '../../../EventBus';
import ClickOutside from 'vue-click-outside'
import _ from 'lodash';

export default {
  data() {
    return {
      showOptions: false,
      processing: false,
      lastPreferredStatus: null,
      lastSetNow: null // It represents the last set status at current action batch
    }
  },
  directives: {
    ClickOutside
  },
  props: {
    latestStatus: {
      type: Array,
      default: () => ([])
    },
    itemStatuses: {
      type: Array,
      default: () => ([])
    },
    id: {
      type: Number
    },
    orderId: {
      type: Number
    },
    tags: {
      type: String
    }
  },
  methods: {
    hide(){
      this.showOptions = false;
    },
    setStatusFromLastSetStatus() {

      

       this.lastPreferredStatus = !_.isEmpty(this.$store.state.status.preferredStatus) ? this.$store.state.status.preferredStatus : null;

       if(this.lastPreferredStatus && this.$store.state.status.itemId != this.id){

         if(this.lastSetNow == this.lastPreferredStatus.value){
            
            this.$toasted.show(
              "Hey! You have already set this status",
              {
                type: "error",
                duration: 4000,
                action: {
                  text: "Close",
                  class: "toastBtnTxt",
                  onClick: (e, toastObject) => {
                    toastObject.goAway(0);
                  },
                },
              }
            );
            return false;
         }

         this.itemStatus(this.id, this.lastPreferredStatus.value, 'Item', {}, this.orderId, "Set from order card", this.lastPreferredStatus.text);

       }
       else{
         this.$toasted.show(
           "Sorry! No last preferred status was found.",
          {
            type: "error",
            duration: 4000,
            action: {
              text: "Close",
              class: "toastBtnTxt",
              onClick: (e, toastObject) => {
                toastObject.goAway(0);
              },
            },
          }
        );
       }
    },
    setStatus(selectedStatus){

      if(this.lastSetNow == selectedStatus.value){
            
            this.$toasted.show(
              "Hey! You have already set this status",
              {
                type: "error",
                duration: 4000,
                action: {
                  text: "Close",
                  class: "toastBtnTxt",
                  onClick: (e, toastObject) => {
                    toastObject.goAway(0);
                  },
                },
              }
            );
            return false;
         }

       this.itemStatus(this.id, selectedStatus.value, 'Item', {}, this.orderId, "Set from order card", selectedStatus.text);
       this.$store.dispatch('status/addPreferredStatus', { selectedStatus,  itemId: this.id});
       
    },
    async itemStatus(id, selected, recordType, item = {}, orderId, note = "", statusName = "") {
      
      this.lastSetNow = selected;

      try{
      if (id && selected && recordType && orderId) {

        this.processing = true;

        let data = {
          statusId: selected,
          orderId,
          note,
          statusName
        }

        const result = await OrderStatusesService.setStatus(data, id, recordType);

          // Update the tag with new status

          let tags = this.tags ? this.tags.split(',') : [];
          tags.push(`~${statusName.trim()}~`);
          tags = removeDuplicates(tags);

          let updateStatus = await OrderTagsService.updateOrderTags(this.orderId, tags);
          EventBus.$emit('order-tag-updated', {
            id: this.orderId,
            tags
          })

          // End update the tag with new status
          
        this.$toasted.show(
           result.data.message,
          {
            type: "success",
            duration: 1000,
            action: {
              text: "Close",
              class: "toastBtnTxt",
              onClick: (e, toastObject) => {
                toastObject.goAway(0);
              },
            },
          }
        );


        EventBus.$emit('status.updated-item-status', updateStatus.data.theOrder);
        this.showOptions = false;

        this.processing = false;

      }
      }
      catch(errors){

         this.$toasted.show(
           "Some problem occurred while setting status. Please try again after sometime",
          {
            type: "error",
            duration: 1000,
            action: {
              text: "Close",
              class: "toastBtnTxt",
              onClick: (e, toastObject) => {
                toastObject.goAway(0);
              },
            },
          }
        );

      }
    } // End status function
  },
  beforeDestroy(){
    EventBus.$off('status.last-preferred-status')
  }
}
</script>

<style lang="scss" scoped>
.quick-status {
  position: relative;
  width: 15px;
  height: 15px;
  top: 12px;
  margin-right: 10px;
  transform: translate(0, -50%);
  z-index: 99;
  float: left;
}

.status-trigger {
  width: 15px;
  height: 15px;
  background-color: rgb(224, 224, 224);
  border-radius: 20px;
  cursor: pointer;
  position: relative;
}

.statusSetterList {
  position: absolute;
  left: 25px;
  transform: translate(0, -50%);
  top: 50%;
  width: 250px;
  background-color: #fff;
  padding: 0 0 0 5px;
  margin: 0;
  list-style-type: none;
  border-left: 3px solid rgb(83, 83, 83);
  &::after{
    content: "";
    position: absolute;
    left: -10px;
    transform: translate(0, -50%);
    top: 50%;
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 5px 10px 5px 0;
    border-color: transparent #545454 transparent transparent;
  }
  li {
    padding: 10px 20px;
    box-shadow: 3px 3px 5px rgba(0, 0, 0, 0.3);
    border-left: 10px solid #fff;
    background-color: #fff;
    cursor: pointer;
    margin-bottom: 4px;
    transition: all 300ms ease;

    &:hover {
      transform: translate(10px, 0)
    }
    &:last-child{
      margin-bottom: 0;
    }
  }
}
.fade-enter-active, .fade-leave-active {
  transition: all .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
  transform: translate(50px, -50%);
}

.spinner{
  position: absolute;
  left: -4px;
  top: -4px;
  opacity: 0.6;
}
</style>
